import { useEffect, useState } from 'react';

const Activities = ({ row, setLevels }) => {
    const [activities, setActivities] = useState(row.EquivalentActivities || []);

    useEffect(() => {
        setLevels((prev) =>
            prev.map((item) =>
                item.Id === row.Id
                ? { ...item, EquivalentActivities: activities }
                : item
            )
        );
    }, [activities]);

    const handleAddActivity = () => {
        setActivities(prev => [
        ...prev,
        {
            Id: `temp-${row.Id}-${activities.length + 1}`,
            text: ''
        }
        ]);
    };

    useEffect(() => {
        setActivities(row.EquivalentActivities)
    }, [row.EquivalentActivities]);

    return {
        activities,
        setActivities,
        handleAddActivity
    }
};

export default Activities;
